import { FormBuilder, FormGroup, FormsModule, Validators, ReactiveFormsModule, } from '@angular/forms';
import { Component } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { UiTable } from '../../../../../components/ui/table/table.component';
import { ModalComponent } from '../../../../../components/modal/modal.component';
import { TableTypeIntervention } from '../../../../../data/schemas/table.schema';
import { TypeInterventionRequest } from '../../../../../data/http/requests/typeintervention.request';
import { TypeInterventionService } from '../../../../../services/typeintervention/typeintervention.service';
import { TypeInterventionResponse } from '../../../../../data/http/responses/typeintervention.response';
import { AppService } from '../../../../../core/app.service';
import { LoaderComponent } from "../../../../../components/ui/loader/loader.component";
import { Input } from '../../../../../components/forms/input/input';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-typeintervention',
  imports: [UiTable, ModalComponent, ReactiveFormsModule, Input, FormsModule, LoaderComponent, UiButtonComponent, loaderIntervantion, ConfirmDialogComponent],
  templateUrl: './typeintervention.component.html',
  styleUrls: ['./typeintervention.component.css'],
  standalone: true
})
export class TypeinterventionPage {
  public tableTypeIntervention = TableTypeIntervention
  public showAddTypeInterventionModal: boolean = false;
  public isLoading: boolean = false;
  /** true while the table skeleton loader is showing */
  public isTableLoading: boolean = true;
  public isEditing: boolean = false;
  public editingTypeIntervention: TypeInterventionResponse | null = null;

  public showDeleteConfirm = false;
  public selectedItem: TypeInterventionResponse | null = null;
  public deleteLoading = false;

  /* Champs */
  typeInterventionForm!: FormGroup;

  public typeInterventions: TypeInterventionResponse[] = [];

  constructor(private typeInterventionService: TypeInterventionService,
    private fb: FormBuilder, private appService: AppService) {
    this.typeInterventionForm = this.fb.group({
      applicationId: this.appService.getAppId(),
      libelle: ['', Validators.required],
      niveau: [0, Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadTypeIntervention();
  }

  save(): void {
    if (this.typeInterventionForm.valid) {
      const appId = this.appService.getAppId();
      if (!appId || appId === 'null') {
        console.error('Impossible de créer une structure : applicationId manquant.');
        return;
      }
      this.isLoading = true;
      const requestBody = { ...this.typeInterventionForm.value, applicationId: appId };
      const processedCode = requestBody.libelle
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s/g, "")
        .toUpperCase();
      if (this.isEditing && this.editingTypeIntervention) {
        this.typeInterventionService.update(this.editingTypeIntervention.id, { ...requestBody, code: processedCode }).subscribe({
          next: () => {
            this.loadTypeIntervention();
            this.closeAddTypeInterventionModal();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la mise à jour de la structure :', error);
            this.isLoading = false;
          }
        });
      } else {
        this.typeInterventionService.create({ ...requestBody, code: processedCode }).subscribe({
          next: (response) => {
            this.typeInterventionForm.reset({
              applicationId: this.appService.getAppId(),
              libelle: '',
              code: "",
              niveau: 0
            });
            this.loadTypeIntervention();
            this.closeAddTypeInterventionModal();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la création du type :', error);
            this.isLoading = false;
          }
        });
      }
    } else {
      this.typeInterventionForm.markAllAsTouched();
      console.warn('Le formulaire de structure est invalide.');
    }
  }

  loadTypeIntervention(): void {
    this.isLoading = true
    this.typeInterventionService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeInterventions = response.data;
        this.isLoading = false
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
        this.isLoading = false
      }
    });
  }

  openAddTypeInterventionModal(): void {
    this.isEditing = false;
    this.editingTypeIntervention = null;
    this.typeInterventionForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: '',
      niveau: 0,
    });
    this.showAddTypeInterventionModal = true;
  }

  closeAddTypeInterventionModal(): void {
    this.showAddTypeInterventionModal = false;
    this.isEditing = false;
    this.editingTypeIntervention = null;
    this.typeInterventionForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: '',
      niveau: 0,
    });
  }

 onEditTask(item: TypeInterventionResponse): void {
  this.isEditing = true;
  this.editingTypeIntervention = item;

  this.typeInterventionForm.patchValue({
    applicationId: this.appService.getAppId(),
    libelle: item.libelle,
    niveau: item.niveau
  });

  this.showAddTypeInterventionModal = true;
}
  openDeleteConfirm(item: TypeInterventionResponse): void {
  this.selectedItem = item;
  this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
  this.showDeleteConfirm = false;
  this.selectedItem = null;
 }

 confirmDelete(): void {
  if (!this.selectedItem) return;

  this.deleteLoading = true;

  this.typeInterventionService.delete(this.selectedItem.id).subscribe({
    next: () => {
      this.loadTypeIntervention();
      this.deleteLoading = false;
      this.cancelDelete();
    },
    error: (error) => {
      console.error("Erreur suppression :", error);
      this.deleteLoading = false;
    }
  });
 }

  onDeleteTypeInteervention(item: TypeInterventionResponse): void {
    this.typeInterventionService.delete(item.id).subscribe(({
      next: () => {
        this.typeInterventionForm.reset({
          applicationId: this.appService.getAppId(),
          libelle: '',
          niveau: 0,
        });
        this.loadTypeIntervention();
        this.isLoading = false;
      },
      error: (error) => {
        console.error("Erreur lors de la suppression du type d'intervention:", error);
        this.isLoading = false;
      }
    }))
  }
}